import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-top">
        <Link onClick={toTop} to="/" className="logo-link">
          <div className="logo">
            <img
              src="/head/danecay-logo.svg"
              alt="danecay"
              className="logo-wordmark"
            />
          </div>
        </Link>
        <div className="header-icons">
          <Link onClick={toTop} to="/cartpage" className="icon-link cart-icon">
            <svg
              className="icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 6h15l-1.5 9h-12z" />
              <circle cx="9" cy="21" r="1" />
              <circle cx="18" cy="21" r="1" />
              <path d="M3 3h2l.4 2M7 13h10" />
            </svg>
            {cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>
      <nav className="main-nav">
        <ul className="nav-list">
          <li className="nav-item">
            <Link onClick={toTop} to="/" className="nav-link">
              HOME
            </Link>
          </li>
          <li className="nav-item">
            <Link onClick={toTop} to="/shop" className="nav-link">
              PRODUCTS
            </Link>
          </li>

          <li className="nav-item">
            <Link onClick={toTop} to="/about" className="nav-link">
              ABOUT US
            </Link>
          </li>
          <li className="nav-item">
            <Link onClick={toTop} to="/shipping" className="nav-link">
              SHIPPING AND RETURN
            </Link>
          </li>
          <li className="nav-item">
            <Link onClick={toTop} to="/contact" className="nav-link">
              CONTACT US
            </Link>
          </li>
          <li className="nav-item nav-more">
            <details>
              <summary className="nav-link">MORE</summary>
              <div className="nav-more-menu">
                <Link onClick={toTop} to="/privacy">Privacy Policy</Link>
                <Link onClick={toTop} to="/terms">Terms of Use</Link>
                <Link onClick={toTop} to="/cookies">Cookie Policy</Link>
                <Link onClick={toTop} to="/faq">FAQs</Link>
              </div>
            </details>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
